import {isShopHostname, resolveShopDomain, SHOP_LOCAL_PREFIX, shopUsesPathOnMainSite} from '~/utils/shopHost'

/**
 * Хост витрины и ссылки между ним и основным сайтом: ссылка на свой хост остаётся
 * относительной, на соседний — абсолютной.
 */
export function useShopHost() {
    const config = useRuntimeConfig()
    const requestUrl = useRequestURL()
    const mainDomain = String(config.public.mainDomain || 'vetsy.ru')
    const shopDomain = resolveShopDomain(config.public.shopDomain as string | undefined, mainDomain)
    const isShopHost = useState('is-shop-host', () => isShopHostname(requestUrl.host, shopDomain))
    const mountOnMainSite = computed(() => !isShopHost.value && shopUsesPathOnMainSite(mainDomain))
    const shopPathPrefix = computed(() => mountOnMainSite.value ? SHOP_LOCAL_PREFIX : '')

    const shopUrl = (path: string): string =>
        isShopHost.value || mountOnMainSite.value ? path : `${requestUrl.protocol}//${shopDomain}${path}`

    const mainSiteUrl = (path: string): string =>
        isShopHost.value ? `${requestUrl.protocol}//${mainDomain}${path}` : path

    const canonicalOrigin = isShopHost.value
        ? `https://${shopDomain}`
        : String(config.public.canonicalDomain || 'https://vetsy.ru')

    return {isShopHost, mountOnMainSite, shopPathPrefix, shopDomain, canonicalOrigin, shopUrl, mainSiteUrl}
}
